<div class="grid-row">
  <div class="grid-col-12" [ngClass]="isOrganTransplantType ? 'padding-bottom-2' : 'padding-bottom-4'">
    <label for="filter-by-name-field" class="usa-label custom-label margin-top-0 filter-by-name"
      >Filter by Center Name
    </label>
    <input
      aria-label="Enter a full or partial name"
      placeholder="Enter a full or partial name"
      id="filter-by-name-field"
      type="search"
      class="usa-input custom-input maxw-full height-5 border-radius-4 filter-by-border-right"
      [(ngModel)]="filterByName"
      (ngModelChange)="handleFilterBy($event)"
    />
  </div>

  <ng-container *ngIf="isOrganTransplantType">
    <div class="usa-accordion padding-bottom-4">
      <h4 class="usa-accordion__heading">
        <button
          type="button"
          class="usa-accordion__button background-color-light-blue"
          [attr.aria-expanded]="canShowOrganSelection"
          aria-controls="organ-selection"
          (click)="handleOrganSelection()"
        >
          Filter By Organ:
        </button>
      </h4>
      <div
        id="organ-selection"
        class="usa-accordion__content border-grey margin-top-1"
        [hidden]="!canShowOrganSelection"
      >
        <form [formGroup]="organTransplantFormGroup">
          <ng-container *ngFor="let organItem of organTypes; let i = index">
            <div class="grid-row display-flex flex-align-center">
              <input
                type="checkbox"
                [id]="organItem.id"
                [value]="organItem.value"
                [formControlName]="organItem.id"
                (change)="handleCheckboxClick(organItem.id)"
              />
              <label class="font-family-public-sans-normal" [for]="organItem.id">{{ organItem.name }}</label>
            </div>
          </ng-container>
        </form>
      </div>
    </div>
  </ng-container>
</div>
